export type NavDropdownItem = {
  title: string;
  href: string;
  description: string;
};

export type NavItem = {
  href?: string;
  title: string;
  dropdownItems?: NavDropdownItem[];
};

export const CAREERS_URL = "https://jobs.ashbyhq.com/versemedical";
export const BLOG_URL = "https://blog.versemedical.com";

export const navItems: NavItem[] = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Our Offerings",
    dropdownItems: [
      {
        title: "Providers",
        description: "Ease the burden of managing DME.",
        href: "/for-providers",
      },
      {
        title: "Payor Network & Contracting",
        description: "A DME solution for the 21st century.",
        href: "/payor-network",
      },
      {
        title: "Payor Case Management",
        description:
          "Automate & streamline DME ordering while improving compliance.",
        href: "/payor-case-management",
      },
    ],
  },
  {
    title: "About",
    href: "/about",
  },
  {
    title: "News & Insights",
    href: BLOG_URL,
  },
  {
    title: "Life at Verse",
    href: "/life-at-verse",
  },
  {
    title: "Careers",
    href: CAREERS_URL,
  },
  {
    title: "Contact",
    href: "/contact",
  },
];

export const MOBILE_MENU_ANIMATION_DURATION = 300;
